module.exports = __webpack_public_path__ + "img/13.13b5d681.png";